import { defineMessages } from "react-intl";

export const messages = defineMessages({
  storeSetup: {
    id: "+Cv1cr",
    defaultMessage: "Store Setup",
    description: "wizard layout eyebrow",
  },
  onboardingWizard: {
    id: "nEJ9pY",
    defaultMessage: "Onboarding Wizard",
    description: "wizard layout title",
  },
  onboardingWizardDescription: {
    id: "zrpT/v",
    defaultMessage: "Complete the core setup steps to prepare your storefront for launch.",
    description: "wizard layout description",
  },
});
